(() => {
  const memberDiscount = 0.9;
  const moneyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  function isMember() {
    return window.EPIC_GARDENING?.isGreenhouseMember === true;
  }

  function parseCurrencyToCents(value) {
    if (value == null) return null;
    const numeric = Number(String(value).replace(/[^0-9.-]/g, ''));
    if (!Number.isFinite(numeric)) return null;
    return Math.round(numeric * 100);
  }

  function formatMoney(cents) {
    return moneyFormatter.format((Number(cents) || 0) / 100);
  }

  function getTestPriceCents(variantId) {
    if (!variantId || !window.igData?.price?.getPriceByVariantId) return null;
    return parseCurrencyToCents(window.igData.price.getPriceByVariantId(String(variantId)));
  }

  function getTestCompareCents(variantId) {
    if (!variantId || !window.igData?.price?.getComparePriceByVariantId) return null;
    return parseCurrencyToCents(window.igData.price.getComparePriceByVariantId(String(variantId)));
  }

  function getVariantId(el) {
    return (
      el?.dataset?.variantId ||
      el?.dataset?.selectedVariantId ||
      el?.querySelector?.('[data-variant-id]')?.dataset?.variantId ||
      el?.closest?.('[data-variant-id]')?.dataset?.variantId ||
      ''
    );
  }

  function applyMemberPrice(priceRoot) {
    if (!priceRoot || priceRoot.dataset.memberEligible === 'false') return;

    const memberDisplay = priceRoot.querySelector('.price__member-display');
    if (!memberDisplay) return;

    const variantId = getVariantId(priceRoot);
    const testPriceCents = getTestPriceCents(variantId);
    if (testPriceCents == null) return;

    const memberPriceCents = Math.ceil(testPriceCents * memberDiscount);
    const compareCents = getTestCompareCents(variantId);
    const strikeCents = compareCents && compareCents > testPriceCents ? compareCents : testPriceCents;

    const priceEl = memberDisplay.querySelector('.price-item--sale.price-item--last, .price-item--sale');
    const strikeEl = memberDisplay.querySelector('.price-item--regular');

    if (priceEl) priceEl.textContent = formatMoney(memberPriceCents);
    if (strikeEl) strikeEl.textContent = formatMoney(strikeCents);
  }

  function applySearchMemberPrice(card) {
    if (!card || card.dataset.memberEligible === 'false') return;

    const variantId = getVariantId(card);
    const testPriceCents = getTestPriceCents(variantId);
    if (testPriceCents == null) return;

    const priceLine = card.querySelector('.ais-hit--price');
    if (!priceLine) return;

    const memberPriceCents = Math.ceil(testPriceCents * memberDiscount);
    const compareCents = getTestCompareCents(variantId);
    const strikeCents = compareCents && compareCents > testPriceCents ? compareCents : testPriceCents;

    const priceEl = priceLine.querySelector('.igPrice');
    const strikeEl = priceLine.querySelector('.igComparePrice');

    if (priceEl) priceEl.textContent = formatMoney(memberPriceCents);
    if (strikeEl) {
      strikeEl.textContent = formatMoney(strikeCents);
    } else if (priceEl && strikeCents > memberPriceCents) {
      priceEl.insertAdjacentHTML('beforebegin', `<span class="igComparePrice">${formatMoney(strikeCents)}</span>`);
    }
  }

  function applyGuestSavings(root) {
    const variantId = getVariantId(root);
    const testPriceCents = getTestPriceCents(variantId);
    if (testPriceCents == null) return;

    const savingsCents = Math.max(0, testPriceCents - Math.ceil(testPriceCents * memberDiscount));
    root.querySelectorAll('.member-savings-amount').forEach((el) => {
      el.textContent = formatMoney(savingsCents);
    });
  }

  function syncIntelligemsMemberPrices() {
    if (!window.igData?.price) return;

    if (isMember()) {
      document.querySelectorAll('.price[data-variant-id], .price [data-variant-id]').forEach((el) => {
        const priceRoot = el.classList?.contains('price') ? el : el.closest('.price');
        applyMemberPrice(priceRoot);
      });
      document.querySelectorAll('.ais-hit[data-member-eligible="true"]').forEach(applySearchMemberPrice);
      return;
    }

    document.querySelectorAll('.price[data-variant-id], .ais-hit[data-member-eligible="true"]').forEach(applyGuestSavings);
  }

  function scheduleSync() {
    syncIntelligemsMemberPrices();
    window.setTimeout(syncIntelligemsMemberPrices, 50);
    window.setTimeout(syncIntelligemsMemberPrices, 250);
  }

  document.addEventListener('DOMContentLoaded', scheduleSync);
  window.addEventListener('load', scheduleSync);
  window.addEventListener('ig:ready', scheduleSync);
  document.addEventListener('ig:pricesUpdated', scheduleSync);
  window.setTimeout(scheduleSync, 750);
  window.setTimeout(scheduleSync, 2000);
})();
